<ion-menu
  contentId="main-content"
  menuId="first"
  side="start"
  [disabled]="disabled"
  type="overlay"
>
  <ion-header
    [attr.data-test]="'Automation.btn-principal-menu-title' | translate"
    mode="md"
  >
    <ion-toolbar color="darkblue" class="ion-text-center" mode="md">
      <ion-title>Menú</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-list mode="md" lines="full" class="content-items">
      <ng-container *ngFor="let item of moreOptions; let i = index">
        <ion-item
          [attr.data-test]="
            ('Automation.btn-principal-menu-' | translate) + setMenuName(item)
          "
          (click)="navTo(item)"
          mode="md"
          button
          type="button"
          class="no-padding-start"
          [ngStyle]="{ display: item.active ? 'unset' : 'none' }"
        >
          <ion-img
            [src]="item.iconUrl"
            slot="start"
            class="icon-section"
          ></ion-img>
          <ion-label class="fuente-mas" [innerHTML]="item.title"></ion-label>
        </ion-item>
      </ng-container>
    </ion-list>

    <ion-text color="primary" class="info-text">
      <ion-icon [src]="worldIcon" class="icon"></ion-icon>
      <p class="info-p darkish-blue-text" (click)="openUrl()">GEPP.com.mx</p>
    </ion-text>

    <p class="p-version">
      Versión {{ version }}
      <ng-container *ngIf="!isProd"> ({{ versionCode }}) </ng-container>
    </p>
  </ion-content>

  <ion-footer mode="md">
    <ion-toolbar color="white" mode="md">
      <ion-item
        (click)="clearData(logout)"
        lines="none"
        mode="md"
        button
        type="button"
      >
        <ion-img
          [src]="logout.iconUrl"
          slot="start"
          class="icon-section"
        ></ion-img>
        <ion-label class="fuente-mas">{{ logout.title }}</ion-label>
      </ion-item>
    </ion-toolbar>
  </ion-footer>
</ion-menu>
